import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnboardingListElementComponent } from './onboarding-list-element.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { IconButtonModule } from '../../components/icon-button/icon-button.module';
import { ColorModule } from '../../components/colors/color.module';


@NgModule({
  declarations: [OnboardingListElementComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    TranslateModule,
    IconButtonModule,
    ColorModule
  ],
  exports: [OnboardingListElementComponent]
})
export class OnboardingListElementModule {
}
